
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Inventory, InventoryStockTaking, InventoryStockTakingEntry } from '../../../backend/backendapi';
import { formatDateTimeForInput, parseDateTimeFromInput, WindowType } from '../../../../util';
import { paginationOptions, searchOptions } from '../../../../util/vue-good-table';
import { Like } from '../../../../util/Like';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import InventorySelectModal from './InventorySelectModal';

declare var window: WindowType;

type Row = {
  entry: InventoryStockTakingEntry;
  inventory: Inventory | undefined;
}

@Component({
  components: {
    InventorySelectModal,
    VueGoodTable,
  },
})
export default class StockTakingEditor extends Vue {
  @Prop({ required: true })
  stockTaking!: InventoryStockTaking;
  @Prop({ required: true })
  isNew!: boolean;

  get columnsConfig(): any[] {
    return [
      {
        label: this.$t('maintenance.inventory.stockTakingEntry.model.inventory').toString(),
        field: (e: InventoryStockTakingEntry) => [e.inventoryIdent, e.inventoryName].filter(e => !!e).join(' - '),
      },
      {
        label: this.$t('maintenance.inventory.stockTakingEntry.model.stockBefore').toString(),
        field: (e: InventoryStockTakingEntry) => e.stockBefore,
      },
      {
        label: this.$t('maintenance.inventory.stockTakingEntry.model.stockAfter').toString(),
        field: (e: InventoryStockTakingEntry) => e.stockAfter,
      },
      {
        label: this.$t('maintenance.inventory.stockTakingEntry.model.packageCountBefore').toString(),
        field: (e: InventoryStockTakingEntry) => e.packageCountBefore,
      },
      {
        label: this.$t('maintenance.inventory.stockTakingEntry.model.packageCountAfter').toString(),
        field: (e: InventoryStockTakingEntry) => e.packageCountAfter,
      },
      {
        label: this.$t('maintenance.inventory.stockTakingEntry.model.comment').toString(),
        field: (e: InventoryStockTakingEntry) => e.comment,
      },
      {
        label: this.$t('general.actions').toString(),
        field: 'actions',
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get scheduledAt(): string {
    return formatDateTimeForInput(this.stockTaking.scheduledAt);
  }

  set scheduledAt(val: string) {
    this.stockTaking.scheduledAt = parseDateTimeFromInput(val);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  onEntryRemove(row: Like<InventoryStockTakingEntry>) {
    const index = this.stockTaking.entries.findIndex(entry => entry.id === row.id);
    if (index >= 0) {
      this.stockTaking.entries.splice(index, 1);
    }
  }

  onInventoriesSelected(inventories: Inventory[]): void {
    //remove duplicates
    const alreadyAddedInventoryIds = new Set(this.stockTaking.entries.map(entry => entry.inventoryId));
    inventories = inventories.filter(e => !alreadyAddedInventoryIds.has(e.id!));

    //map
    const newEntries = inventories.map(e => InventoryStockTakingEntry.fromJS({
      id: crypto.randomUUID(),
      createdAt: new Date(),
      createdBy: window.application.user.id,
      updatedAt: new Date(),
      updatedBy: window.application.user.id,
      inventoryId: e.id,
      inventoryIdent: e.ident,
      inventoryName: e.name,
    }));
    this.stockTaking.entries.push(...newEntries);
    (this.$refs.selectModal as InventorySelectModal).dismiss();
  }

  openSelectModal(): void {
    (this.$refs.selectModal as InventorySelectModal).open();
  }
}
